/**
 * Formats a brewery name with optional city/town and state for consumption-place display.
 * @param {Record<string, unknown> | null | undefined} breweryData
 * @returns {string}
 */
export function formatBreweryConsumptionLabel(breweryData) {
  if (!breweryData || typeof breweryData !== 'object') {
    return 'Brewery';
  }

  const name = typeof breweryData.name === 'string' ? breweryData.name.trim() : '';
  const cityRaw = breweryData.city ?? breweryData.town;
  const city = typeof cityRaw === 'string' ? cityRaw.trim() : '';
  const state = typeof breweryData.state === 'string' ? breweryData.state.trim() : '';

  const locationParts = [city, state].filter((part) => part.length > 0);
  if (locationParts.length === 0) {
    return name.length > 0 ? name : 'Brewery';
  }
  if (name.length === 0) {
    return locationParts.join(', ');
  }
  return `${name} (${locationParts.join(', ')})`;
}
